import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api`;

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const onboardingApi = {
  get: () => axios.get(`${API_URL}/onboarding`, { headers: getHeaders() }),
  skip: (key) => axios.post(`${API_URL}/onboarding/steps/${key}/skip`, {}, { headers: getHeaders() }),
  shared: () => axios.post(`${API_URL}/onboarding/shared`, {}, { headers: getHeaders() }),
  inviteFamily: (email) => axios.post(`${API_URL}/onboarding/invite-family`, { email }, { headers: getHeaders() }),
  addCoach: (data) => axios.post(`${API_URL}/users`, { ...data, role: 'COACH' }, { headers: getHeaders() }),
  resendEmailConfirmation: (clubId) => axios.post(`${API_URL}/clubs/${clubId}/email/confirm`, {}, { headers: getHeaders() }),
  billingSetup: () => axios.post(`${API_URL}/booking/payouts/billing-setup`, { returnTo: 'home' }, { headers: getHeaders() }),
};

// Starts the Checkout for paying Run The Club, then leaves for Stripe's page
export async function startBillingSetup() {
  const res = await onboardingApi.billingSetup();
  window.location.assign(res.data.url);
}

export const errorMessage = (err, fallback = 'Something went wrong. Please try again.') =>
  err?.response?.data?.error || err?.response?.data?.message || fallback;
